import React from "react";
import { useField } from "formik";
import { CategoryDropdown } from "@components/category/CategoryDropdown";
import { TransactionRuleConditionFormSchema } from "../constants";
interface Props {
    index: number;
}

export const CategoryConditionForm: React.FC<Props> = ({ index }) => {
    const [field, , helpers] = useField<
        TransactionRuleConditionFormSchema["categoryIds"]
    >(`conditions.${index}.categoryIds`);

    return (
        <CategoryDropdown
            buttonSize="default"
            categoryIds={field.value ?? []}
            onChange={(categories) => helpers.setValue(categories)}
        />
    );
};
